enum ScanOptionEnum {
    Positive = 'positive',
    Negative = 'negative',
}

export default ScanOptionEnum;
